<script>
import includes from 'lodash/includes'
import map from 'lodash/map'
import find from 'lodash/find'
import isNumber from 'lodash/isNumber'
import get from 'lodash/get'
import Field from './../components/Field.vue'

import EventBus from './../eventBus.js'

export default {
  name: 'campaign-detail',
  components: {},
  props: {
      target: {
          type: Number,
          required: false,
          default: 0
      },

      donatedAmount: {
          type: Number,
          required: false,
          default: 100,
      },
  },
  data() {
      return {
	needrecepit: 0,
        hasError: false,
        isFormShown: false,
        showFormBtnLabel: 'Show Form',
        amount: '',
        amountErrorMsgKey: 0,
        message: '',
        email: '',

	receipt : '',
	receiptname : '',
	rmethod : '',
	receiptaddr : '',

        errorMsg: {
            amount: {

            },

            message: {

            },

	    message1: {

            },

	    message2: {

            },

	    message3: {

            },

	    message4: {

            },

            email: {

            }
        }
      }
  },
  mounted() {
      this.errorMsg = globalVars.campaignFundRaisingForm.errorMsg;
  },
  computed: {
      globalVars() {
          return this.$root.globalVars
      },

      targetPercentage() {
          return Math.round(this.donatedAmount / this.target * 100);
      },

      amountError() {
          if (this.amount === '') {
              this.amountErrorMsgKey = 0;
          } else if (isNaN(this.amount) || this.amount < 30) {
              this.amountErrorMsgKey = 1;
          } else if (isNaN(this.amount) || this.amount > 1000000) {
              this.amountErrorMsgKey = 2;
          }

          return this.hasError && (this.amount === '' || isNaN(this.amount) || this.amount < 30 || this.amount > 1000000);
      },

      messageError() {
          return this.hasError && this.message === '';
      },

      messageError1() {
    //  alert(this.receipt);
          return this.hasError && this.receiptname === '' && this.receipt == true ;
      },

       messageError2() {
          return this.hasError && this.rmethod === '' && this.receipt == true ;
      },

      messageError3() {
	if ( this.rmethod == '1'  )
	{
	  return this.hasError && this.receipt == true && !this.receiptaddr.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/);
	}
	else
          return this.hasError && this.receiptaddr === '' && this.receipt == true ;
      },

      messageError4() {
          return this.hasError && this.receipt === '';
      },

      emailError() {
          return this.hasError && (this.email === '' || !this.email.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/));
      }
  },
  methods: {
      toggleForm() {
          if (this.isFormShown) {
              this.isFormShown = false;
              this.showFormBtnLabel = 'Show Form';
          } else {
              this.isFormShown = true;
              this.showFormBtnLabel = 'Hide Form';
          }
      },

      checkRecepit(){
		this.needrecepit = this.receipt ? 1 : 0 ;//1 - this.needrecepit;
	},

      numberOnly: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },

      submit() {

     // alert(this.receipt);
          if ((this.amount === '' || isNaN(this.amount)) || this.message === '' || (this.email === '' || !this.email.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)) ) {
              this.hasError = true;
              return false;
          }

	  if (this.receipt == true )
	  {
		if (this.receiptname === '' ||  this.rmethod === '' || this.receiptaddr === '' ) {
		      this.hasError = true;
		      return false;
		  }
		else if (  this.rmethod == '1' && !this.receiptaddr.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)  ) {
		      this.hasError = true;
		      return false;
		  }
	  }

          this.hasError = false;
          this.$refs.form.submit();
      }
  },
  watch: {

  }
}
</script>
